import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import MainNavigation from './MainNavigation';
import './MainHeader.css';

const MainHeader = ({ currentPage = 'home', onVisibilityChange }) => {
  const headerRef = useRef(null);

  useEffect(() => {
    // Skip if no callback provided
    if (!onVisibilityChange) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Callback with visibility state
        onVisibilityChange(entry.isIntersecting);
      },
      { 
        threshold: 0,
        rootMargin: '0px'
      }
    );

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [onVisibilityChange]);

  return (
    <header className="main-header" ref={headerRef}>
      <div className="header-content">
        <div className="header-logo">
          <img src="/assets/svgs/clothedEye.svg" alt="ClothedEye" />
        </div>
        <MainNavigation currentPage={currentPage} />
        <div className="header-tagline">
          <img src="/assets/svgs/clothedEye_BMDITS.svg" alt="BMDITS" />
        </div>
      </div>
    </header>
  );
};

MainHeader.propTypes = {
  currentPage: PropTypes.string,
  onVisibilityChange: PropTypes.func
};

export default MainHeader;
